module.exports = "<div class='header-bar'>\n  <div class='logo'>\n    <img src='../../assets/images/logo.png' />\n  </div>\n</div>\n"